import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import {
  DnvFeatureLayer, DnvMapState, LayerType, Layer as DnvLayer, LayerState, DnvFieldMeta, StartDraw, DnvLatLng, SetEditFeatures,
  GetEditFeaturesGeometry, AddSnapLayers, SetSurroundingFeatureList, RevertFeatureGeometry, SetEditFeaturesGeometry, EditingFeature
} from 'dnv-lib';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Action } from '@ngrx/store';
import { CheckLayerDisplay, DelayedAction, GetMaxAssetId, readOnlyFields, RefreshDisplayedGeoJson, requiredFields, SetEditFeatureShowActiveLayer, SetFeatureRasterHighlight } from 'src/app/state-management';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-edit-features',
    templateUrl: './edit-features.component.html',
    styleUrls: ['./edit-features.component.scss'],
    standalone: false
})

export class EditFeaturesComponent implements OnInit, OnChanges {
  @ViewChild('deleteConfirm') deleteConfirm: TemplateRef<any>;
  // @ViewChild('saveBtn') saveBtn: ElementRef;
  @ViewChild('updateBtn') updateBtn: ElementRef;

  @Input() editFeature: { featureType: string, featureLayerId: number, shape: string };
  @Input() headerHeight: number;
  @Input() panelHeight: number;
  @Input() mapState: DnvMapState;
  @Input() layerState: LayerState;
  @Input() selectedFeature: Array<[string, string]>;
  @Input() featureAdded: boolean;
  @Input() maxAsset: { assetId: string, name: string };
  @Input() showSpinner: boolean;
  @Input() snapAsset: string;
  @Input() fields: any;
  @Input() requiredFields: requiredFields[];
  @Input() readOnlyFields: readOnlyFields[];
  @Input() isDesktop: boolean;
  @Input() editingFeature: boolean;
  @Input() showLayers: boolean;

  @Output() highlightFeature = new EventEmitter<{ url: string, objectId: number }>();
  @Output() selectFeature = new EventEmitter<{
    objectId: string, url: string, writeUrl: string,
    allowInsp: boolean, featureId: number, assetId: string
  }>();
  @Output() featureTypeEmitter = new EventEmitter<any>();
  @Output() newFeatureEmitter = new EventEmitter<string>();
  @Output() saveFeatureEmitter = new EventEmitter<any>();
  @Output() deleteFeatureEmitter = new EventEmitter<any>();
  @Output() confirmDeleteEmitter = new EventEmitter<any>();
  @Output() setEditFeaturesEmitter = new EventEmitter<boolean>();
  @Output() revertGeometryEmitter = new EventEmitter<any>();
  @Output() actionEmitter = new EventEmitter<Action>();
  @Output() snapEmitter = new EventEmitter<boolean>();
  @Output() showActiveLayerEmitter = new EventEmitter<boolean>();

  featureForm: UntypedFormGroup;
  readOnly = true;
  modal: NgbModalRef = null;

  // meta: DnvFieldMeta[];
  prevFeatureType: string;
  newFeature = false;
  formCtrls: {
    ctrlName: string,
    inputType: string,
    label: string,
    domain: { name: string, code: string }[],
    required: boolean,
    readOnly: boolean
  }[] = [];
  initialValues: any;
  newAssetId = '';
  prevSnapAsset = '';
  editAssetId = '';
  prevFields: any = null;
  showActiveForm: UntypedFormGroup = new UntypedFormGroup({
    showActiveLayers: new UntypedFormControl(false)
  });

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    if (this.editFeature && this.editFeature.featureType.length === 0) {
      this.featureForm = new UntypedFormGroup({});
    }

    this.showActiveForm.get('showActiveLayers').setValue(this.showLayers);

  }

  ngOnChanges(_e: any) {
    if (this.selectedFeature && this.selectedFeature.length > 0 && this.readOnly) {
      this.setFeatureValues();
    }
    if (this.editFeature.featureType !== this.prevFeatureType || this.prevFields !== this.fields) {
      this.getFeatureFields();
    }

    if (this.featureAdded || this.mapState.editFeatures) {
      if (!this.readOnly) {
        this.enableEditFields();
      }


      // if (this.saveBtn) {
      //   this.saveBtn.nativeElement.disabled = false;
      // }

    } else {

      this.featureForm.disable();
      // if (this.saveBtn) {
      //   this.saveBtn.nativeElement.disabled = true;
      // }

    }

    // so far only water main breaks has 'snap to asset' field
    if (this.prevSnapAsset !== this.snapAsset) {
      if (this.mapState.editFeaturesPermission && this.mapState.editFeaturesPermission.autoIncrementField) {
        // const assetIdentifier = this.mapState.editFeaturesPermission.autoIncrementField.toLowerCase();
        Object.keys(this.featureForm.controls).forEach(key => {
          if (key.toLowerCase().indexOf('asset_id') > -1) {
            this.featureForm.get(key).setValue(this.snapAsset);
            // this.editAssetId = this.snapAsset;
          }
        });
      }
    }
    this.prevSnapAsset = this.snapAsset;

    if (_e.maxAsset) {
      this.getNextAssetId();
    }

    if (_e.showLayers) {
      this.showActiveForm.get('showActiveLayers').setValue(this.showLayers);
    }
  }

  clearFeatureType(featureLayerId: number): void {
    this.featureTypeEmitter.emit({ featureType: '', featureLayerId });
    this.actionEmitter.emit(new StartDraw({ shape: 'cancel', guid: '' }));
    if (this.newFeature) {
      this.newFeature = false;
      this.readOnly = true;
    }
    if (this.maxAsset && this.maxAsset.name) {
      this.featureForm.get(this.maxAsset.name).setValue('');
    }
    this.newAssetId = '';
  }

  clearMultiResults() {
    this.actionEmitter.emit(new SetSurroundingFeatureList(null));
    this.actionEmitter.emit(new SetFeatureRasterHighlight({}));
    this.actionEmitter.emit(new DelayedAction([new RefreshDisplayedGeoJson()]));
  }

  mouseEnter(objectId: number, gisLyrNum: number, name: string): void {
    const matchingLayers: DnvFeatureLayer[] = this.mapState.featureLayers
      .filter((fl: any) => Number(fl.gisLayerNum) === gisLyrNum && fl.displayName === name);
    if (1 === matchingLayers.length) {
      this.highlightFeature.emit({ url: matchingLayers[0].url, objectId });
    }
  }

  mouseLeave(): void {
    this.highlightFeature.emit(null);
  }

  setFeatureDetails(objectId: string, url: string, writeUrl: string, allowInsp: boolean, featureId: number, assetId: string): void {
    this.selectFeature.emit({ objectId, url, writeUrl, allowInsp, featureId, assetId });
  }

  getFeatureFields() {

    const group: { [id: string]: UntypedFormControl } = {};
    this.featureForm = new UntypedFormGroup({});
    this.formCtrls = [];

    if (this.fields) {
      for (let i = 0; i < this.fields.length; i++) {
        group[this.fields[i].name] = new UntypedFormControl({ value: '', disabled: true });
        let inputType = 'text';
        let readOnly = false;
        let domain = [];
        if (this.fields[i].domain && this.fields[i].domain.codedValues && this.fields[i].domain.codedValues.length > 0) {
          inputType = 'select';
          for (let x = 0; x < this.fields[i].domain.codedValues.length; x++) {

            domain.push({
              name: this.fields[i].domain.codedValues[x].name,
              code: this.fields[i].domain.codedValues[x].code
            });
          }
        }

        // check if there's subtype for layer
        const featureLayer = this.mapState.featureLayers.filter(fl => fl.featureLayerId === this.editFeature.featureLayerId);
        if (featureLayer && featureLayer.length > 0) {
          const subTypeField = featureLayer[0].subTypeField;
          if (subTypeField && subTypeField === this.fields[i].name) {
            inputType = 'select';
            if (featureLayer[0].subTypes) {
              for (let sub of featureLayer[0].subTypes) {
                domain.push({
                  name: sub.name,
                  code: sub.id
                });
              }
            }
          }
        }

        if (!this.fields[i].editable) {
          inputType = 'hidden';
        }

        const roLyr = this.readOnlyFields.filter(r => r.featureLayerId === this.editFeature.featureLayerId && r.readOnlyField === this.fields[i].name)
        if (roLyr && roLyr[0]) {
          readOnly = true;
        }

        const requiredFields = this.requiredFields.filter(r => r.featureLayerId === this.editFeature.featureLayerId);
        let isRequired = false;
        if (requiredFields) {
          requiredFields.filter(f => {
            if (f.requiredField === this.fields[i].name) {
              isRequired = true;
            }
          });
        }

        if (this.fields[i].name.indexOf('.') === -1) {
          this.formCtrls.push({
            domain: domain,
            ctrlName: this.fields[i].name,
            label: this.fields[i].alias,
            inputType: inputType,
            required: isRequired,
            readOnly: readOnly
          });
        }

      }
      this.featureForm = new UntypedFormGroup(group);
    }

    this.prevFeatureType = this.editFeature.featureType;
    this.prevFields = this.fields;
  }

  setFeatureValues() {

    for (let i = 0; i < this.selectedFeature.length; i++) {
      const pair = this.selectedFeature[i];
      // get name from meta of layer.featureLayers
      if (this.fields) {
        const key = this.fields.filter((m: { name: string; }) => m.name === pair[0]);
        if (key && key.length > 0) {
          if (this.featureForm && this.featureForm.get(key[0].name)) {
            if (key[0].name.toLowerCase().indexOf('date') === -1) {
              let fieldValue = pair[1];
              if (key[0].domain && key[0].domain.codedValues) {
                const codedVal = key[0].domain.codedValues.filter((v: any) => v.name.toLowerCase() === pair[1].toLowerCase());
                if (codedVal && codedVal[0]) {
                  fieldValue = codedVal[0].code;
                }
              }

              // subtype
              const featureLayer = this.mapState.featureLayers.filter(fl => fl.featureLayerId === this.editFeature.featureLayerId);
              if (featureLayer && featureLayer.length > 0) {
                const subTypeField = featureLayer[0].subTypeField;
                if (subTypeField && subTypeField === pair[0]) {
                  let st = featureLayer[0].subTypes.filter(s => s.name === pair[1]);
                  if (st.length === 0) {
                    st = featureLayer[0].subTypes.filter(s => s.id === Number(pair[1]))
                  }
                  if (st && st[0]) {
                    fieldValue = st[0].id;
                  }
                }
              }
              this.featureForm.get(key[0].name).setValue(fieldValue);
            } else {
              const valid = new Date(parseInt(pair[1])).toUTCString();
              if (pair[1].length >= 10) {
                const formatDate = new DatePipe('en-CA').transform(pair[1], 'yyyy-MM-dd');
                this.featureForm.get(key[0].name).setValue(formatDate);
              } else {
                this.featureForm.get(key[0].name).setValue(pair[1]);
              }

            }

          }
        }

        // OBJECTID is not in this.meta, set value
        if (pair[0].toLowerCase() === 'objectid') {
          if (this.featureForm.get(pair[0])) {
            this.featureForm.get(pair[0]).setValue(pair[1]);
          }
          if (this.mapState.editFeaturesGeometryObjId !== Number(pair[1])) {
            this.actionEmitter.emit(new GetEditFeaturesGeometry(Number(pair[1])));
          }
        }
      }
      this.getAssetId();
    };

    if (this.featureForm) {
      this.initialValues = this.featureForm.value;
    }
    this.featureAdded = false;
  }

  clearFeatureValues() {
    if (this.mapState.selectedFeature && this.mapState.selectedFeature.length > 0) {
      this.selectFeature.emit(null);

      this.featureForm.reset();
    } else if (this.newFeature) {

      this.clearFeatureType(this.editFeature.featureLayerId);
      this.newFeature = false;
      this.featureForm.reset();
      this.deleteNewFeature();
    }

  }

  addNewFeature(shape: string): void {
    this.newFeature = true;
    this.readOnly = false;
    this.featureForm.reset();  // make sure form is blank

    if (shape === 'esriGeometryPoint') {
      this.newFeatureEmitter.emit('feature-marker');
    } else if (shape === 'esriGeometryPolyline') {
      this.newFeatureEmitter.emit('feature-polyline');
    } else if (shape === 'esriGeometryPolygon') {
      this.newFeatureEmitter.emit('feature-polygon');
    }
    this.actionEmitter.emit(new AddSnapLayers(true));

    this.actionEmitter.emit(new GetMaxAssetId({ url: this.mapState.editFeaturesPermission.url, name: this.mapState.editFeaturesPermission.autoIncrementField }));

    if (!this.isDesktop) {
      this.actionEmitter.emit(new EditingFeature(true));
    }

  }

  onEditFeature() {
    this.actionEmitter.emit(new EditingFeature(true));
  }

  getNextAssetId() {
    // generate next asset Id
    if (this.maxAsset && this.maxAsset.assetId && this.maxAsset.assetId !== '') {
      const assetNumber = this.maxAsset.assetId.substring(this.maxAsset.assetId.length - 5);
      let nextAssetStr = null;
      let nextAssetNum = Number(assetNumber) + 1;
      const assetPrefix = this.maxAsset.assetId.substring(0, this.maxAsset.assetId.length - 5);
      if (nextAssetNum.toString().length < 5) {
        const numZeros = 5 - nextAssetNum.toString().length;
        let prefixZeros = '';
        for (let i = 0; i < numZeros; i++) {
          prefixZeros = prefixZeros + '0';
        }
        if (Number(nextAssetNum)) {
          nextAssetStr = prefixZeros.toString() + nextAssetNum.toString();
        }

      } else {
        nextAssetStr = nextAssetNum.toString();
      }
      if (nextAssetStr) {
        const newAssetID = assetPrefix + nextAssetStr;
        if (this.featureForm.get(this.maxAsset.name)) {
          this.featureForm.get(this.maxAsset.name).setValue(newAssetID);
        }

        this.newAssetId = newAssetID;
      }

    } else {
      // no auto increment id
      this.newAssetId = '';
    }
  }

  getAssetId(): void {
    if (this.mapState.editFeaturesPermission && this.mapState.editFeaturesPermission.autoIncrementField) {
      const assetIdentifier = this.mapState.editFeaturesPermission.autoIncrementField.toLowerCase();
      if (this.selectedFeature && this.selectedFeature.length > 0) {
        const asset = this.selectedFeature.filter(f => f[0].toLowerCase() === assetIdentifier);
        if (asset) {
          if (asset.length === 0) {
            this.editAssetId = 'No Asset ID';
          } else {
            this.editAssetId = asset[0][1];
          }
        }
      }
    }
  }

  editForm(): void {
    this.readOnly = false;

    // this.featureForm.enable();
    this.enableEditFields();

    if (this.updateBtn) {
      this.updateBtn.nativeElement.disabled = false;
    }

    this.setEditFeaturesEmitter.emit(true);

  }

  enableEditFields(): void {
    Object.keys(this.featureForm.controls).forEach(key => {
      const keyLower = key.toLowerCase();
      const ctrl = this.formCtrls.filter(fc => fc.ctrlName === key);
      if (ctrl && ctrl[0]) {
        if (!ctrl[0].readOnly) {
          this.featureForm.get(key).enable();
        }
      }
      // if (keyLower === 'replacedasset_id') {  // field specifically used in infrastructure projects and needs to be editable
      //   if (this.featureForm.get(key)) {
      //     this.featureForm.get(key).enable();
      //   }
      // } else if (keyLower.indexOf('edited') === -1 && keyLower.indexOf('created') === -1 && key.indexOf(this.maxAsset.name) === -1 && keyLower.indexOf('asset') === -1) {
      //   if (this.featureForm.get(key)) {
      //     this.featureForm.get(key).enable();
      //   }
      // } else {
      //   if (this.featureForm.get(key)) {
      //     this.featureForm.get(key).disable();
      //   }
      // }
    });
  }

  cancelForm(isRevert: boolean): void {
    if (this.newFeature) {
      this.featureForm.reset();
      this.deleteNewFeature();
    } else {
      this.featureForm.reset(this.initialValues);
    }
    this.readOnly = true;
    this.newFeature = false;

    Object.keys(this.featureForm.controls).forEach(key => {
      if (this.featureForm.controls[key]) {
        this.featureForm.controls[key].disable();
      }
    });
    this.featureForm.disable();

    this.actionEmitter.emit(new StartDraw({ shape: 'cancel', guid: '' }));

    if (isRevert) {
      this.revertGeometryEmitter.emit();
    }

  }

  saveFeature() {
    if (this.maxAsset && this.maxAsset.name) {
      this.featureForm.get(this.maxAsset.name).enable();  // disabled form controls are not included in this.featureForm.value
    }

    this.saveFeatureEmitter.emit({ formValues: this.featureForm.value, action: 'save', shape: this.editFeature.shape });
    this.readOnly = true;
    this.newFeature = false;
    this.cancelForm(false);
  }

  dismiss(): void {
    if (this.modal) {
      this.modal.dismiss();
    }
  }

  open(modal: TemplateRef<any>): void {
    this.modal = this.modalService.open(modal);
  }

  deleteFeature() {
    this.modal = this.modalService.open(this.deleteConfirm, { centered: true });
  }

  // delete feature chosen
  confirmDelete() {
    //TODO: delete feature
    this.modal.close();
    const obj = this.mapState.selectedFeature.filter((f: any) => f[0].toLowerCase() === 'objectid');
    this.confirmDeleteEmitter.emit(obj[0][1]);
  }

  // deletes feature added to map
  deleteNewFeature() {
    this.deleteFeatureEmitter.emit();
  }

  updateFeature() {
    if (this.maxAsset && this.maxAsset.name) {
      this.featureForm.get(this.maxAsset.name).enable();  // disabled form controls are not included in this.featureForm.value
    }
    const isFormDiff = this.compareFormValues(this.initialValues, this.featureForm.value);
    if (isFormDiff) {
      this.saveFeatureEmitter.emit({ formValues: this.featureForm.value, action: 'update', shape: this.editFeature.shape });
    } else {
      this.saveFeatureEmitter.emit({ formValues: null, action: 'update' });
    }

    this.readOnly = true;
    this.newFeature = false;
    this.cancelForm(false);
  }

  compareFormValues(initVals: any, newVals: any): boolean {
    let result = false;
    Object.keys(initVals).forEach(key => {
      if (initVals[key] !== newVals[key]) {
        result = true;
      }
    });

    return result;
  }

  toggleSnap() {
    this.snapEmitter.emit(this.mapState.snapToLayers);
  }

  onSubmit() {
    if (this.newFeature) {
      this.saveFeature();
    } else {
      this.updateFeature();
    }
  }

  toggleActiveLayer(evt: any) {
    this.showActiveLayerEmitter.emit(evt.target.checked);
  }

}
